<template>
    <div class="otherbox">
        <!-- 关联被告信息 -->
        <div class="htit">
            <div class="h2">其他信息</div>
            <div class="rt">
                <a-button type="primary" ghost icon="edit" @click='visibleShow("OtherType");'
                    v-if='$common.AccAUTH(debInfo.accuser_id, "debtor:edit") && debInfo.is_clear != 1'>修改
                </a-button>
            </div>
        </div>
        <div class="nselectbox">
            <div class="paddingBox">
                <a-row type='flex' v-if="test_model == 1">
                    <!-- <a-col :span="4">
                        <label>诉讼地位准确：</label>
                        <span>{{ debInfo.is_role_exact == 3 ? '混合' : (debInfo.is_role_exact == 1 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span="4">
                        <label>诉讼完毕：</label>
                        <span>{{ debInfo.cause_is_complete == 0 ? '否' : '是' }}</span>
                    </a-col>
                    <a-col :span='4'>
                        <label>代偿完毕：</label>
                        <span>{{ debInfo.is_full_pay == 1 ? '不详' : (debInfo.is_full_pay == 2 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span='4'>
                        <label>最后代偿时间：</label>
                        <span>{{ debInfo.last_compensation_time | yearFormat }}</span>
                    </a-col> -->
                </a-row>
                <a-row type='flex' style="margin-bottom:20px;" v-if="test_model == 2">
                    <!-- <a-col :span="4">
                        <label>诉讼地位准确：</label>
                        <span>{{ debInfo.is_role_exact == 3 ? '混合' : (debInfo.is_role_exact == 1 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span="4">
                        <label>诉讼完毕：</label>
                        <span>{{ debInfo.cause_is_complete == 0 ? '否' : '是' }}</span>
                    </a-col>
                    <a-col :span='4'>
                        <label>代偿完毕：</label>
                        <span>{{ debInfo.is_full_pay == 1 ? '不详' : (debInfo.is_full_pay == 2 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span='4'>
                        <label>最后代偿时间：</label>
                        <span>{{ debInfo.last_compensation_time | yearFormat }}</span>
                    </a-col> -->
                </a-row>
                <a-row type='flex' style="margin-bottom:20px;" v-if="test_model == 3">
                    <!-- <a-col :span="4">
                        <label>2诉讼地位准确：</label>
                        <span>{{ debInfo.is_role_exact == 3 ? '混合' : (debInfo.is_role_exact == 1 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span="4">
                        <label>诉讼完毕：</label>
                        <span>{{ debInfo.cause_is_complete == 0 ? '否' : '是' }}</span>
                    </a-col>
                    <a-col :span='4'>
                        <label>代偿完毕：</label>
                        <span>{{ debInfo.is_full_pay == 1 ? '不详' : (debInfo.is_full_pay == 2 ? '是' : '否') }}</span>
                    </a-col> -->
                    <!-- <a-col :span='4'>
                        <label>最后代偿时间：</label>
                        <span>{{ debInfo.last_compensation_time | yearFormat }}</span>
                    </a-col> -->
                </a-row>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        test_model: Number
    },
    name: 'OtherTypes',
    computed: {
        ...mapGetters([
            'debInfo',
            'APIKEY',
        ])
    },
    methods: {
        visibleShow(name) {
            this.$store.dispatch("openkey", { key: name, by: true })

        },
    }
}
</script>